module.exports = "/rate/components/rateModal-e274bf.html";